import React from 'react';
//import Header from '../components/Header'
import '../styles/ForbiddenPage.css'
function ForbiddenPage() {
    return (
        <div>
            <h1 className="forbidden-message1">Error 404</h1>
            <h2 className="forbidden-message2">Oops... Page Not Found.</h2>
        </div>
    )
}

export default ForbiddenPage;
